import store from './store'
import AppArchiveProduct from './AppArchiveProduct.vue'
import { createApp } from 'vue'

export default {
    target: document.getElementById('welcom-products'),
    init () {

        if(this.target){

            const app = createApp(AppArchiveProduct)

            app.config.globalProperties.$filters = {
                price(value) {
                    return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(value)
                }
            }

            app.use(store)
            app.mount('#welcom-products')
        }

    }
}
